<ng-container *ngIf="vm$ | async as vm">
  <div class="report-card" [ngClass]="cardClass" *ngIf="vm.loading">
    <mat-progress-spinner
      diameter="24"
      mode="indeterminate"
    ></mat-progress-spinner>
  </div>

  <div
    class="report-card"
    [ngClass]="cardClass"
    *ngIf="!vm.loading && vm.reports.length === 1"
  >
    <span [matTooltip]="(vm.reports[0].tooltip$ | async) || ''">
      <button
        mat-flat-button
        [disabled]="vm.reports[0].disabled$ | async"
        (click)="onClick(vm.reports[0].id)"
      >
        <span>{{ buttonLabel }}</span>
        <mat-icon>picture_as_pdf</mat-icon>
      </button>
    </span>
  </div>

  <div
    class="report-card"
    [ngClass]="cardClass"
    *ngIf="!vm.loading && vm.reports.length > 1"
  >
    <button mat-flat-button [matMenuTriggerFor]="reportMenu">
      <span>Reports</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #reportMenu="matMenu">
      <button
        mat-menu-item
        *ngFor="let r of vm.reports; trackBy: trackById"
        [disabled]="r.disabled$ | async"
        (click)="onClick(r.id)"
      >
        <mat-icon>picture_as_pdf</mat-icon>
        <div class="report-menu-item">
          <span>{{ r.menuTitle }}</span>
          <small>{{ r.menuSubtitle$ | async }}</small>
        </div>
      </button>
    </mat-menu>
  </div>
</ng-container>
